import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { PortalManagementSubscriptionService } from 'src/app/features/portal/_services/management/portal-management-subscription.service';

/**
 * Admin-only correction tool: directly renames a subscription's account
 * reference (and its linked circuit's number, if one exists). Database
 * only - does not notify TECH8/Smart OLT, so only safe to use when the
 * network side was never told about the wrong reference in the first
 * place.
 */
@Component({
  selector: 'app-change-account-reference-dialog',
  templateUrl: './change-account-reference-dialog.component.html',
  styleUrls: ['./change-account-reference-dialog.component.scss']
})
export class ChangeAccountReferenceDialogComponent {
  form: FormGroup = this.fb.group({
    new_account_reference: ['', Validators.required]
  });

  submitting = false;
  errorMessage = '';

  constructor(
    private fb: FormBuilder,
    public config: DynamicDialogConfig,
    private ref: DynamicDialogRef,
    private pmss: PortalManagementSubscriptionService
  ) {}

  get subscription(): any {
    return this.config.data?.subscription;
  }

  onSubmit(): void {
    this.errorMessage = '';

    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    const subscriptionId = this.subscription?.id;
    if (!subscriptionId) {
      this.errorMessage = 'No subscription selected - please close and try again.';
      return;
    }

    this.submitting = true;
    this.pmss
      .changeSubscriptionAccountReference(
        subscriptionId,
        this.form.value.new_account_reference
      )
      .subscribe({
        next: (res) => {
          this.submitting = false;
          this.ref.close({ success: true, data: res?.data });
        },
        error: (error) => {
          this.submitting = false;
          this.errorMessage =
            error?.error?.detail || 'Failed to change account reference. Please try again.';
        }
      });
  }

  closeDialog(): void {
    this.ref.close();
  }
}
